<template>
	<div
		:style="animationStyle"
		class="btn-plusempty"
		:class="{ 'bottom-btn-hover': isHovering }"
		@click="tapTop"
		@mouseenter="isHovering = true"
		@mouseleave="isHovering = false"
	>
		<i class="iconfont icon-v2_huidingbu"></i>
	</div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';

interface Props {
	scrollTop?: number;
	scrollContainer?: HTMLElement | Window;
}

const props = withDefaults(defineProps<Props>(), {
	scrollTop: 0,
	scrollContainer: undefined,
});

const isHovering = ref(false);
const isVisible = ref(false);

// 监听 scrollTop 变化控制显示/隐藏
watch(
	() => props.scrollTop,
	newVal => {
		isVisible.value = newVal >= 100;
	}
);

// 计算动画样式
const animationStyle = computed(() => ({
	opacity: isVisible.value ? 1 : 0,
	transition: 'opacity 0.8s ease',
}));

// 平滑滚动到顶部
const tapTop = () => {
	const container = props.scrollContainer || window;
	const startPosition = container === window ? window.scrollY || document.documentElement.scrollTop : (container as HTMLElement).scrollTop;

	const duration = 500;
	const startTime = performance.now();

	const easeInOutQuad = (t: number): number => {
		return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
	};

	const animateScroll = (currentTime: number) => {
		const timeElapsed = currentTime - startTime;
		const progress = Math.min(timeElapsed / duration, 1);
		const ease = easeInOutQuad(progress);

		if (container === window) {
			window.scrollTo(0, startPosition * (1 - ease));
		} else {
			(container as HTMLElement).scrollTop = startPosition * (1 - ease);
		}

		if (timeElapsed < duration) {
			requestAnimationFrame(animateScroll);
		}
	};

	requestAnimationFrame(animateScroll);
};
</script>

<style scoped lang="scss">
.btn-plusempty {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 3rem;
	height: 3rem;
	background: #7f90f5;
	position: fixed;
	bottom: 7.25rem;
	right: 1.5rem;
	border-radius: 100%;
	overflow: hidden;
	text-align: center;
	cursor: pointer;
}

.bottom-btn-hover {
	background: #7f90f5 !important;
}

.icon-v2_huidingbu {
	color: #fff;
	font-size: 1.5rem;
	font-weight: bold;
}
</style>
